export default function sendAnalyticsEvent(type, detail = {}) {
  document.dispatchEvent(new CustomEvent('analytics', {
    detail: { type: type, ...detail }
  }));
}
